import src from "IMAGE";
export default { src, width: 125, height: 38, blurWidth: 0, blurHeight: 0};
